<template>
  <div v-wechat-title="title" style="height:100%">
    {{title}}
  </div>
</template>
<script>
export default {
    name: `OrganizationWard`,
    props: {

    },
    data() {
        return {
            title: `组织架构-院区`
        }
    },
    computed: {

    },
    mounted() {

    },
    methods: {

    }
}
</script>
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Organization/Ward/Index.vue